import type { FragmentType } from '@/gql/codegen';
import type React from 'react';
import { type TERMS_OF_USE_ITEM, TermsOfServicePage } from '../-Page';

export type TermsOfServiceContainerProps = {
  termsOfUseData: FragmentType<typeof TERMS_OF_USE_ITEM>;
  onAgreeTerms: () => Promise<void>;
  agreeTermsMutationLoading: boolean;
};

export const TermsOfServiceContainer = ({
  termsOfUseData,
  onAgreeTerms,
  agreeTermsMutationLoading,
}: TermsOfServiceContainerProps) => {
  return (
    <TermsOfServicePage
      termsOfUseData={termsOfUseData}
      onAgreeTerms={onAgreeTerms}
      agreeTermsMutationLoading={agreeTermsMutationLoading}
    />
  );
};
